/**
 * @file seasonSlice.js
 * @description Sets initial state for the warehouse module.  Creates reducers and actions for API Calls
 * @author Ben Yee
 */
import { createSlice } from '@reduxjs/toolkit';
import {
    addStyleToSeason,
    deleteStyleFromSeason,
    getSeason,
    getSeasonDocuments,
    getSeasonStyles,
    getSeasons,
    importMastersStylesToSeason,
    udpateSeason,
    updateSeasonGroupShot,
    uploadCSVtoSeason,
    getSignedUploadUrl,
    uploadPDFtoSeason,
    getSeasonStylesPaginated

} from '../../services/seasonService';
import { logger } from 'utils/logger';
import { addGuideToSession, addStyleToSession, udpateSession } from 'services/sessionService';
import { updateSample } from 'services/samplesService';
import { SampleFilterModel } from 'core/models/SampleFilterModel';
import { purgeFilters } from 'utils/helper';
import { DocumentFilterModel } from 'core/models/DocumentFilterModel';

//  const filterSeasons = (samples,filter) => {
//    return samples.filter(sample => {
//      var match = false;
//      // filter by brand
//      if(filter.brands){
//        match = filter.brands.indexOf(sample.facet_brand) > -1?true:false;
//      }else{
//        match = true;
//      }
//      logger.log(match, ' MATCH')
//      return match;
//    })
//  }

const seasonSlice = createSlice({
    name: 'season',
    initialState: {
        seasons: [],
        selectedSeason: null,
        selectedSeasons: [],
        selectedSamples: [],
        searchCursor: null,
        seasonFilter: {
            brands: [],
            categories: [],
            department: [],
            location: [],
            status: [{ sampleCount: '' }, { taskCount: '' }, { photographyCount: '' }],
            colour: '',
            keyword: '',
            sortBy: {},
            tags: [],
            deadline: { dateStart: '', dateEnd: '' },
            channels: [],
        },
        // seasonSampleFilter: { ... new SampleFilterModel() },
        seasonSampleFilters: {},
        seasonDocumentFilters: {},
        displayPrefs: {
            createAnotherStyleFlag: false,
        },
        // Meta
        error: null,
        success: null,
        loading: false,
        action: null,
    },
    reducers: {
        onServiceStart(state, action) {
            state.error = null;
            state.success = null;
            state.loading = true;
        },

        onServiceFailure(state, action) {
            state.error = action.payload;
            state.success = null;
            state.loading = false;
        },

        selectSeason(state, action) {
            logger.log('Setting Season: ', action.payload);
            state.selectedSeason = action.payload ? { ...action.payload } : null;
        },

        selectSeasons(state, action) {
            logger.log('setting selected samples', action.payload);
            state.selectedSeasons = action.payload ? [...action.payload] : [];
        },

        selectSamples(state, action) {
            logger.log('setting selected samples', action.payload);
            state.selectedSamples = action.payload ? [...action.payload] : [];
        },

        setSeasonFilter(state, action) {
            logger.log('Setting Season: ', action.payload);
            state.seasonFilter = action.payload ? { ...action.payload } : null;

            // filter the samples.
            // const samples = filterSeasons(state.samples, state.sampleFilter);
        },

        setSeasonSampleFilters(state, action) {
            logger.log(action);
            // state.seasonSampleFilters = action.payload ? { ...action.payload } : null;
            const seasonId = action.payload.seasonId ?? null;
            if (seasonId) {
                // state.sessionSampleFilters[sessionId] = action.payload ? { ...action.payload } : null;
                var filter =
                    state.seasonSampleFilters[action.payload.seasonId] && state.seasonSampleFilters[action.payload.seasonId].filter
                        ? state.seasonSampleFilters[action.payload.seasonId].filter
                        : { ...new SampleFilterModel() };
                state.seasonSampleFilters = {
                    ...state.seasonSampleFilters,
                    [action.payload.seasonId]: {
                        timestamp: Date.now(),
                        filter: {
                            ...filter,
                            ...action.payload.filter,
                        },
                    },
                };
            }
        },
        setSeasonDocumentFilters(state, action) {
            logger.log(action);
            // state.seasonSampleFilters = action.payload ? { ...action.payload } : null;
            const seasonId = action.payload.seasonId ?? null;
            if (seasonId) {
                // state.sessionSampleFilters[sessionId] = action.payload ? { ...action.payload } : null;
                var filter =
                    state.seasonDocumentFilters[action.payload.seasonId] && state.seasonDocumentFilters[action.payload.seasonId].filter
                        ? state.seasonDocumentFilters[action.payload.seasonId].filter
                        : { ...new DocumentFilterModel() };
                state.seasonDocumentFilters = {
                    ...state.seasonDocumentFilters,
                    [action.payload.seasonId]: {
                        timestamp: Date.now(),
                        filter: {
                            ...filter,
                            ...action.payload.filter,
                        },
                    },
                };
            }
        },

        cleanupUnusedFilters(state, action) {
            const newFilters = purgeFilters(state.seasonSampleFilters);
            return {
                ...state,
                seasonSampleFilters: newFilters,
            };
        },

        setDisplayPrefs(state, action) {
            state.displayPrefs = { ...action.payload };
        },

        //////////////////////
        //
        // SINGLE Season
        //
        //////////////////////
        getSeasonStart(state, action) {
            state.success = null;
            state.error = null;
        },
        getSeasonSuccess(state, action) {
            logger.log('getSeasonSuccess : SUCCESS');

            state.loading = false;
            state.success = { type: action.type, message: 'Get Event Success' };
            // if(action.payload.urls){
            //   state.selectedProject = {...state.selectedProject, urls:action.payload.urls}
            // }
            state.selectedSeason = { ...action.payload };
            //state.openIssuesCount = action.payload.open_issues_count
            state.error = null;
        },
        getSeasonFailure(state, action) {
            logger.log(state, action, 'fail');
            state.error = action.payload;
        },

        //////////////////////
        //
        // GET JOBS
        //
        //////////////////////
        getSeasonsStart(state, action) {
            state.success = null;
            state.error = null;
        },
        getSeasonsSuccess(state, action) {
            logger.log('getSeasonSuccess : SUCCESS');

            state.loading = false;
            state.success = { type: action.type, message: 'Get Events Success' };

            state.seasons = [...action.payload];
            //state.openIssuesCount = action.payload.open_issues_count
            state.error = null;
        },
        getSeasonsFailure(state, action) {
            logger.log(state, action, 'fail');
            state.error = action.payload;
        },

        //////////////////////
        //
        // SEASON STYLE
        //
        //////////////////////
        fetchSeasonStylesSuccess(state, action) {
            logger.log('getSeasonSuccess : SUCCESS');

            // state.loading = false;
            // state.success = { type: action.type, message: 'Get Event Styles Success' };

            // state.selectedSeason.styles = [...action.payload];
            // //state.openIssuesCount = action.payload.open_issues_count
            // state.error = null;

            logger.log('updateCapturesSuccess : SUCCESS')
            
            if(action.payload.complete){
                state.success = { type: action.type, message: 'Get Event Styles Success' };
                state.loading = false;
            }else{
                state.loading = true;
            }

            const items = action.payload.concatItems?[...state.selectedSeason.styles].concat(...action.payload.items):[...action.payload.items];
            state.selectedSeason.styles = [...items];
            state.searchCursor = action.payload.cursor;

            state.error = null
        },

        removeStyleFromSeasonSuccess(state, action) {
            logger.log('getSeasonSuccess : SUCCESS');

            state.loading = false;
            state.success = { type: action.type, message: 'Removed Styles Success' };

            //state.openIssuesCount = action.payload.open_issues_count
            state.error = null;
        },

        //////////////////////
        //
        // SEASON DOCUMENTS
        //
        //////////////////////
        fetchSeasonDocumentsSuccess(state, action) {
            logger.log('getSeasonSuccess : SUCCESS');

            state.loading = false;
            state.success = { type: action.type, message: 'Get Event Documents Success' };

            state.selectedSeason.documents = [...action.payload];
            //state.openIssuesCount = action.payload.open_issues_count
            state.error = null;
        },

        //////////////////////
        //
        // SEASON GROUP SHOT
        //
        //////////////////////
        updateGroupShotSuccess(state, action) {
            logger.log('getSeasonSuccess : SUCCESS');

            state.loading = false;
            state.success = { type: action.type, message: 'Group Shot successfully updated' };

            state.error = null;
        },

        //////////////////////
        //
        // SEASON
        //
        //////////////////////

        createSeasonSuccess(state, action) {
            logger.log('getSeasonSuccess : SUCCESS');

            state.loading = false;
            state.success = { type: action.type, message: 'Event successfully created' };

            //state.seasons = [...action.payload];
            //state.openIssuesCount = action.payload.open_issues_count
            state.error = null;
        },

        updateSeasonStart(state, action) {
            state.success = null;
            state.error = null;
        },
        updateSeasonSuccess(state, action) {
            logger.log('getSeasonSuccess : SUCCESS');

            state.loading = false;
            state.success = { type: action.type, message: 'Events successfully updated' };

            //state.seasons = [...action.payload];
            //state.openIssuesCount = action.payload.open_issues_count
            state.error = null;
        },
        updateSeasonFailure(state, action) {
            logger.log(state, action, 'fail');
            state.error = action.payload;
        },

        uploadCSVToSeasonSuccess(state, action) {
            logger.log(state, action, 'success');
            state.success = { type: action.type, message: 'Events CSV Successfully uploaded' };

            //state.seasons = [...action.payload];
            //state.openIssuesCount = action.payload.open_issues_count
            state.error = null;
        },

        uploadPDFToSeasonSuccess(state, action) {
            logger.log(state, action, 'success');
            state.success = { type: action.type, message: 'Events PDF Successfully uploaded' };

            state.error = null;
        },

        updateSeasonStyleSuccess(state, action) {
            state.loading = false;
            state.success = { type: action.type, message: 'Style successfully updated' };

            state.error = null;
        },

        importMastersStylesToSeasonSuccess(state, action) {
            state.loading = false;
            state.success = { type: action.type, message: 'Styles successfully imported' };

            state.error = null;
        },

        //////////////////////
        //
        // SESSIONS
        //
        //////////////////////
        createSessionSuccess(state, action) {
            logger.log(action.type.toString());

            // const sessions = [...state.sessions];
            // sessions.push(action.payload);

            // state.sessions = [sessions];
            // state.selectedSession = { ...action.payload };

            state.loading = false;
            state.success = { type: action.type, message: 'Create Session Success', data: action.payload };

            //state.sessions = [...action.payload];
            //state.openIssuesCount = action.payload.open_issues_count
            state.error = null;
        },

        assignStylesToSessionSuccess(state, action) {
            state.loading = false;
            state.success = { type: action.type, message: 'Styles successfully assigned', data: action.payload };

            state.error = null;
        },

        batchUpdateStyleSuccess(state, action) {
            var season = { ...state.selectedSeason };
            var styles = [...state.selectedSeason.styles];
            logger.log(action.payload);
            const idMap = new Map(action.payload.map((item) => [item.stylenumber, item]));

            // update the talent
            const tmpStyles = styles.map((style) => {
                if (idMap.get(style.stylenumber)) {
                    const updatedStyle = { ...idMap.get(style.stylenumber) };
                    return { ...style, ...updatedStyle, 
                        channels: updatedStyle.channels?.length ? updatedStyle.channels.split(',') : [],
                        sampleCount:updatedStyle.sampleCount??0
                    };
                } else {
                    return style;
                }
            });

            logger.log(tmpStyles, 'tmpStyles');
            state.selectedSeason = { ...season, styles: tmpStyles };

            state.loading = false;
            state.success = { type: action.type, message: 'Styles successfully updated', data: action.payload };

            state.error = null;
        },

        clearNotifications(state, action) {
            state.error = null;
            state.success = null;
        },
    },
});

// SAMPLE
export const fetchSeason = (id, user) => async (dispatch) => {
    try {
        logger.log(id, ' IN SLICE');
        dispatch(getSeasonStart());
        const data = await getSeason(id, user);
        dispatch(getSeasonSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(getSeasonFailure(err));
    }
};

// GUIDES
export const fetchSeasons = (criteria, user) => async (dispatch) => {
    try {
        dispatch(getSeasonsStart());
        const data = await getSeasons(criteria, user ? user.rawIdToken : '');
        dispatch(getSeasonsSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(getSeasonsFailure(err));
    }
};

export const createSeason = (season, user) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        const data = await udpateSeason(season, user ? user.rawIdToken : '');
        dispatch(createSeasonSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(onServiceFailure(err));
    }
};

// GUIDE UPDATE
export const updateSeason = (season, user) => async (dispatch) => {
    try {
        dispatch(updateSeasonStart());

        const data = await udpateSeason(season, user ? user.rawIdToken : '');
        // const uploadurl = await getUploadUrl(data);
        // const uploadData = await uploadSeasonFile(season);

        dispatch(updateSeasonSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const deleteSeason = (task, user) => async (dispatch) => {
    try {
        dispatch(updateSeasonStart());
        const data = await deleteSeason(task, user ? user.rawIdToken : '');
        dispatch(updateSeasonSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const assignStylesToSeason = (season, style) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        const data = await addStyleToSeason(season, style);
        dispatch(assignStyleToSeasonSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const removeStylesFromSeason = (season, styles) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        for (let i = 0; i < styles.length; i++) {
            const style = styles[i];
            await deleteStyleFromSeason(season, style);
        }

        dispatch(removeStyleFromSeasonSuccess(styles));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const fetchSeasonStyles = (season, style, signal, cursor='', maxRequestCount) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        // const data = await getSeasonStyles(season, style, signal);
        // dispatch(fetchSeasonStylesSuccess(data));


        var origCursor = cursor;
        var items = [];
        var index = 0;
        var resetCursor = true;
        var tmpCursor;
        var concatItems = true;

        do{
            const data = await getSeasonStylesPaginated(season, style, cursor, signal);
            cursor = data.nextCursor;

            if(data && data.items){
                items.push(...data.items);
            }
            
            if(!maxRequestCount)
                dispatch(fetchSeasonStylesSuccess({items:[...items],complete:false}));
            
            if(maxRequestCount && (maxRequestCount - 1) === index){
                tmpCursor = cursor;
                cursor = null;
            };

            ++index;

        }while(cursor)

        if(tmpCursor){
        const decodedString = decodeURIComponent(tmpCursor);
        // const obj = JSON.parse(decodedString);
        logger.log(decodedString)
        }
        
        // if(origCursor && origCursor.length && maxRequestCount){
        //   concatItems = true;
        // }

        // if(tmpCursor){
        //   concatItems = true;
        // }

        if(origCursor === '' && maxRequestCount){
        concatItems = false;
        }else if(!maxRequestCount){
        concatItems = false;
        }

        dispatch(fetchSeasonStylesSuccess({items:[...items], complete:true, cursor:tmpCursor, concatItems:concatItems}));

        
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const fetchSeasonDocuments = (season, signal) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        const data = await getSeasonDocuments(season, signal);
        dispatch(fetchSeasonDocumentsSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const createSession = (session, user, season) => async (dispatch) => {
    logger.log('create session from season');
    try {
        dispatch(onServiceStart());
        const data = await udpateSession(session, user ? user.rawIdToken : '');

        if (session.styles) {
            const styles = session.styles;
            var items = [];
            for (let i = 0; i < styles.length; i++) {
                const style = { ...styles[i] };
                const result = await addStyleToSession(style, data, season);
                items.push(result);
            }
        }

        if (session.guides) {
            const guides = session.guides;
            var guideItems = [];
            for (let i = 0; i < guides.length; i++) {
                const guide = { ...guides[i] };
                const result = await addGuideToSession(guide, data, user ? user.rawIdToken : '');
                guideItems.push(result);
            }
        }

        dispatch(createSessionSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const assignStylesToSession = (session, styles, season) => async (dispatch) => {
    logger.log('create session from season');
    try {
        dispatch(onServiceStart());

        if (styles) {
            var items = [];
            for (let i = 0; i < styles.length; i++) {
                const style = { ...styles[i] };
                const result = await addStyleToSession(style, session, season);
                items.push(result);
            }
        }

        dispatch(assignStylesToSessionSuccess(session));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const batchUpdateStyles =
    (styles, season, updateState = true) =>
    async (dispatch) => {
        try {
            dispatch(onServiceStart());
            var dataItems = [];
            // loop over all the task items
            // create a separate task for each item
            for (let i = 0; i < styles.length; i++) {
                await updateSample(season, styles[i]);
                dataItems.push(styles[i]);
            }

            if (updateState) dispatch(batchUpdateStyleSuccess(dataItems));
        } catch (err) {
            logger.log('err', err);
            dispatch(updateSeasonFailure(err));
        }
    };

export const uploadCSVToSeason = (season, type, files) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        const data = await uploadCSVtoSeason(season, type, files[0]);
        dispatch(uploadCSVToSeasonSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const uploadPDFToSeason = (season, type, files) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        // const data = await uploadCSVtoSeason(season, type, files[0]);
        
        const signedData = await getSignedUploadUrl(season, type, files[0]);
        if(signedData && signedData.url){
            const data = await uploadPDFtoSeason(season, type, files[0], signedData.url);
            dispatch(uploadPDFToSeasonSuccess(data));
        }else{
            dispatch(updateSeasonFailure(signedData));
        }   
        // dispatch(uploadPDFToSeasonSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const updateSeasonStyle = (season, sample) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        const data = await updateSample(season, sample);
        dispatch(updateSeasonStyleSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const importMastersStyles = (season, styles) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        const data = await importMastersStylesToSeason(season, styles);
        dispatch(importMastersStylesToSeasonSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const updateGroupShot = (groupShot, season) => async (dispatch) => {
    try {
        dispatch(onServiceStart());
        var data = null;
        // if the groupShot has an id, then we need to update the sample
        if(groupShot.id){
            data = await updateSample(season, groupShot);
        } else {
            data = await updateSeasonGroupShot(groupShot, season);
        }
        dispatch(updateGroupShotSuccess(data));
    } catch (err) {
        logger.log('err', err);
        dispatch(updateSeasonFailure(err));
    }
};

export const {
    onServiceStart,
    onServiceFailure,
    selectSeason,
    selectSeasons,
    setSeasonFilter,
    setSeasonSampleFilters,
    setSeasonDocumentFilters,
    setDisplayPrefs,
    cleanupUnusedFilters,

    getSeasonStart,
    getSeasonFailure,
    getSeasonSuccess,

    getSeasonsStart,
    getSeasonsFailure,
    getSeasonsSuccess,

    createSeasonSuccess,

    assignStyleToSeasonSuccess,

    removeStyleFromSeasonSuccess,

    fetchSeasonStylesSuccess,

    fetchSeasonDocumentsSuccess,

    createSessionSuccess,

    assignStylesToSessionSuccess,
    batchUpdateStyleSuccess,
    uploadCSVToSeasonSuccess,
    uploadPDFToSeasonSuccess,

    updateSeasonStart,
    updateSeasonSuccess,
    updateSeasonFailure,

    // updateSeasonStyle,
    updateSeasonStyleSuccess,
    importMastersStylesToSeasonSuccess,
    
    updateGroupShotSuccess,
    

    clearNotifications,
} = seasonSlice.actions;

export default seasonSlice.reducer;
